import React from 'react';

import MobileMenuLink from './mobileMenuLink';
import MobileMenuCollpase from './mobileMenuCollapse';

const MobileMenuTabPanelContent = ({
  label,
  data,
}) => (
  <ul className="mobile_menu__tab__panel__content">
    {data.map(({ title, path, collapseData }) => (
      <li
        key={`mobile-menu-tabs-panel-${label}-content-${title}`}
        className="mobile_menu__tab__panel__item"
      >
        {path && <MobileMenuLink title={title} path={path} />}

        {collapseData && (
          <MobileMenuCollpase label={title} data={collapseData} />
        )}
      </li>
    ))}
  </ul>
);

export default MobileMenuTabPanelContent;
